import IntroImage from "../../introImage.component";
import { FormattedMessage } from "react-intl";
import StandardHeadline from "../../../elements/text/standardHeadline.text";
import StandardText from "../../../elements/text/standardText.text";

export default function Instruction(props) {
  return (
    <>
      <div
        className="d-flex w-100 h-100 flex-column justify-content-center"
        style={{ maxWidth: "30rem" }}
      >
        <StandardHeadline className="mb-3">
          <FormattedMessage id="intro.welcomeScreen.title" />
        </StandardHeadline>
        <StandardText>
          <FormattedMessage id="intro.welcomeScreen.text" />
        </StandardText>
      </div>
    </>
  );
}
